import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {MonthlyKpiValue, MonthlyKpiValuesQueryKey} from '../types'

import {type ExpertSystemEquipmentType} from '@domain/expert-system'

export const useMonthlyKpiValue = (
  kpiTargetEquipmentType: ExpertSystemEquipmentType,
  year: number,
  month: number,
  options?: Omit<
    UseQueryOptions<MonthlyKpiValue[], AxiosError, MonthlyKpiValue[]>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery({
    queryKey: [MonthlyKpiValuesQueryKey, kpiTargetEquipmentType, year, month],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<MonthlyKpiValue[]>(
        `/expert-system/kpis/${kpiTargetEquipmentType}/monthly`,
        {
          params: {year, month},
          signal
        }
      )
      return response.data
    },
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    ...options
  })
}
